import { Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

export const CustomAddButton = ({
  handleClick,
}: {
  handleClick: () => void;
}) => {
  return (
    <Button
      onClick={handleClick}
      startIcon={<AddIcon />}
      variant="text"
      size="small"
      sx={{ textTransform: "none" }}
    >
      Add User
    </Button>
  );
};
